export default __webpack_public_path__ + "static/media/logo.09279da8.webp";